import { Injectable } from '@angular/core';

import { RequestService } from './request.service';

@Injectable()
export class SearchService {
  api = {
    root: '/search',
    suggest: '/suggest',
  };

  constructor(private client: RequestService) {}

  public search(query: string) {
    return this.client.get({
      uri: this.api.root + `?query=${encodeURI(query)}`,
    });
  }

  public suggest(query: string) {
    return this.client.get({
      uri: this.api.root + this.api.suggest + `?query=${encodeURI(query)}`,
    });
  }
}
